export default "__VITE_ASSET__c37c87ad__"